import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Router} from "@angular/router";

@Component({
    selector: 'user-info',
    templateUrl: '../../templates/partials/user-services.html'
})

export class UserInfoComponent implements OnInit {
    public servicesTab = "next";
    public officeSelected = "all";
    public buttonIndex;
    @Input() services;
    @Output() showModalEmitter = new EventEmitter();
    constructor(private router: Router) { }

    public selectServicesOffice(value: string) {
        this.officeSelected = value;
    }

    public showTab(tabValue: string){
        this.servicesTab = tabValue;
    }

    public goServiceDetail(id: string) {
        this.router.navigate(["/services", id]);
    }

    public mouseEnter(data: string) {
        this.buttonIndex = data;
    }

    public mouseLeave(data: string) {
        this.buttonIndex = null;
    }

    public showModalBill($event: any, service: object) {
        $event.stopPropagation();
        this.showModalEmitter.emit(service);
    }

    ngOnChanges() {
        //console.log(this.services);
    }
    

    ngOnInit() {
        //console.log(this.services);
     }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/user-services.component.ts